import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ArticleContent from './components/ArticleContent';
import ArticleSidebar from './components/ArticleSidebar';
import Footer from './components/Footer';

export default function TravelInsuranceGuide() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <HeroSection />
      
      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Visa & Travel Tips</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Bảo hiểm du lịch</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <ArticleContent />
          </div>
          <div className="lg:col-span-1">
            <ArticleSidebar />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}